import { INITIAL_TOUR } from './initial-tour';
import { OnboardingTours } from '../onboarding.enums';
import { ROUTE_TOUR } from './route';
import { PRODUCT_CONFIGURATION } from './product-configuration';
import { ROUTE_ITEM_TOUR } from './route-item';
import { CAPACITY_TOUR } from './capacity';
import { SCHEDULE_TOUR } from './schedule';
import { PRICING_TOUR } from './pricing';
import { OPTION_TOUR } from './option';
import { OnboardingStep } from '../onboarding.types';
import { PREVIEW_TOUR } from './preview';
import { PRODUCT_LIST_TOUR } from './product-list';
import { BOOKING_CREATION_TOUR } from './booking-creation';

const tourMap: Record<OnboardingTours, OnboardingStep[]> = {
    [OnboardingTours.INITIAL]: INITIAL_TOUR,
    [OnboardingTours.ROUTE]: ROUTE_TOUR,
    [OnboardingTours.PRODUCT_CONFIGURATION]: PRODUCT_CONFIGURATION,
    [OnboardingTours.ROUTE_ITEM]: ROUTE_ITEM_TOUR,
    [OnboardingTours.CAPACITY]: CAPACITY_TOUR,
    [OnboardingTours.SCHEDULE]: SCHEDULE_TOUR,
    [OnboardingTours.PRICING]: PRICING_TOUR,
    [OnboardingTours.OPTION]: OPTION_TOUR,
    [OnboardingTours.PREVIEW]: PREVIEW_TOUR,
    [OnboardingTours.PRODUCT_LIST]: PRODUCT_LIST_TOUR,
    [OnboardingTours.BOOKING_CREATION]: BOOKING_CREATION_TOUR,
};

export default tourMap;
